import { useMemo } from 'react'
import type { ReactNode } from 'react'

import { applyHighlight, buildKeywordPattern } from './highlightKeywords'

export function useHighlightKeywords(
  keywords: string[],
): (content: string) => ReactNode[] {
  const pattern = useMemo(() => buildKeywordPattern(keywords), [keywords])
  return useMemo(() => (content: string) => applyHighlight(content, pattern), [pattern])
}
